import { useContext } from 'react'
import { LanguageContext } from '../../contexts/language'
import './LanguageSwitcher.css'

const LanguageSwitcher = () => {
  const { language, setLanguage } = useContext(LanguageContext)

  return (
    <div className="language-switcher">
      <button
        type="button"
        className={`lang-btn${language === 'de' ? ' active' : ''}`}
        onClick={() => setLanguage('de')}
        aria-label="Deutsch"
      >
        🇩🇪 DE
      </button>
      <button
        type="button"
        className={`lang-btn${language === 'en' ? ' active' : ''}`}
        onClick={() => setLanguage('en')}
        aria-label="English"
      >
        🇬🇧 EN
      </button>
    </div>
  )
}

export default LanguageSwitcher
